import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import store from '../../store';
import setLocales from '../../store/setLocales';
import { Action } from '../../actions';
import { AppType } from './reducer';
import Utils from '../../utils';
import { initializeMultiAppAuthentication } from '../MultiAppAuthentication/actions';
import UserAgentUtils from '../../utils/userAgent';
import LocalStorageManager from '../../utils/localStorage/manager';

enum AppInfosActionKeys {
	ACCEPT_COOKIE = '@@app/ACCEPT_COOKIE',
	SET_APP_TYPE = '@@app/SET_APP_TYPE',
	SET_USER_LOCALE = '@@app/SET_USER_LOCALE'
}

interface AcceptCookieAction extends Action {
	type: AppInfosActionKeys.ACCEPT_COOKIE;
}

interface SetAppTypeAppAction extends Action {
	type: AppInfosActionKeys.SET_APP_TYPE;
	appType: AppType;
}

interface SetAppUserLocaleAction extends Action {
	type: AppInfosActionKeys.SET_USER_LOCALE;
	locale: string;
}

type AppInfosAction = AcceptCookieAction
	| SetAppTypeAppAction
	| SetAppUserLocaleAction;

const getAppType = (): Promise<AppType> => {
	if (!UserAgentUtils.isMobileApp) {
		return Promise.resolve(AppType.Single);
	}

	return Utils.fetchText(`./.gallery/config/isMultiAppEnabled`, 'GET', undefined, true)
		.then(res => res === 'true' ? AppType.Multiple : AppType.Single)
		.catch(() => AppType.Single);
};

const initializeApp = () => (dispatch: Dispatch<StoreState>): Promise<void | {}> => {
	return getAppType()
		.then(appType => {
			dispatch({ type: AppInfosActionKeys.SET_APP_TYPE, appType });

			if (appType === AppType.Multiple) {
				dispatch(initializeMultiAppAuthentication());
			}

			// check if it has has been fully initialized
			// if not, delete everything from file system & LocalStorage
		});
};

const setUserLocale = (locale: string, hasPrefix: boolean, setLocalStorage: boolean = true) => (dispatch: Dispatch<StoreState>): void => {
	if (setLocalStorage) {
		LocalStorageManager.setUserLocale(locale, hasPrefix);
	}

	dispatch({ type: AppInfosActionKeys.SET_USER_LOCALE, locale });
	setLocales(store, locale);
};

export { AppInfosActionKeys, AppInfosAction, initializeApp, setUserLocale };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/App/actions.ts